import hasuraDataProvider, { GraphQLClient, liveProvider as liveProviderHasura} from "@refinedev/hasura";

const API_URL = import.meta.env.VITE_GRAPHQL_API_URL
if (!API_URL) { console.error("Environment API_URL in App.tsx is undefined, set in .env file.") }

export const client = new GraphQLClient(API_URL, {
    headers: {
        // "x-hasura-role": "anonymous",
    }
});

export const dataProvider = hasuraDataProvider(client);
export const liveProvider = liveProviderHasura(dataProvider);

export default dataProvider
